import { Controller } from "@hotwired/stimulus"

// REMOVE THE THING I AM ATTACHED TO.
//
// One action, no targets, no state — which is the whole argument for it
// being its own controller rather than a method on something bigger. A
// flash banner is the first caller; anything else with a ✕ that only has
// to disappear can use it without inheriting a component's other ideas.
//
// NOT hidden, REMOVED. A dismissed banner that is merely invisible still
// occupies the flash region's gap, so dismissing the first of two left a
// hole above the second.
export default class extends Controller {
  close() {
    // The parent keeps the gap between banners, so a lone dismissed banner
    // would otherwise leave its container's margin behind on an empty
    // region. Cheaper to ask than to have the layout account for it.
    const parent = this.element.parentElement

    this.element.remove()

    if (parent && parent.children.length === 0) parent.remove()
  }
}
